var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"one-category-box"},[_c('div',{staticClass:"one-category-box__image-wrapper"},[_c('b-img',{staticClass:"one-category-box__image",attrs:{"src":_vm.image}})],1),_vm._v(" "),_c('p',{staticClass:"one-category-box__title"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }